import axios from '../request/http';

const userInfo = {
    // 获取用户个人信息
    user(params) {
        return axios.get("/proxy/admin/dashBoard/userBaseInfo", {params});
    },
    // 用户信息列表
    userList(params) {
        return axios.get("/proxy/admin/user/list", {params});
    },
    // 商户待处理
    readyBusinessNum(params) {
        return axios.get("/proxy/admin/business/total", {params});
    },
    // 统计数据
    statistics(params) {
        return axios.get("/proxy/admin/user/total", {params});
    },
    // 用户详情信息
    userDetail(params) {
        return axios.get("/proxy/admin/user/detail", {params});
    },
    // 用户粉丝信息统计
    userFanDetail(params) {
        return axios.get("/proxy/admin/user/detail/total", {params});
    },
    // 用户粉丝列表
    userDetailList(params) {
        return axios.get("/proxy/admin/user/detail/list", {params});
    },
    // 消费列表
    consumeList(params) {
        return axios.get("/proxy/admin/order/user/consumeList", {params});
    },
    // 仪表盘 -- 差异数据统计信息
    userReportData(params) {
        return axios.get("/proxy/admin/dashBoard/diff/total", {params});
    },
    // 仪表盘 -- 收益数据统计
    dashboardProfit(params) {
        return axios.get("/proxy/admin/order/user/revenueTotal", {params});
    },
    // 仪表盘待审核商户
    readyProcessBusinessNum(params) {
        return axios.get("/proxy/admin/business/total", {params});
    },
    // 仪表盘 -- 综合数据分析信息
    analyzeData(params) {
        return axios.get("/proxy/admin/dashBoard/analyze/data", {params});
    },
    // 仪表盘 -- 粉丝排行
    teamLeaderFan(params) {
        return axios.get("/proxy/admin/dashBoard/teamLeader/fans/sort", {params});
    },
    // 仪表盘 -- 收益排名
    profitFan(params) {
        return axios.get("/proxy/admin/dashBoard/teamLeader/revenue/sort", {params});
    },
    // 仪表盘 -- 近期动态列表
    newsInfo(params) {
        return axios.get("/proxy/admin/dashBoard/newsInfo", {params});
    },
    // adminEdit(data) {
    //     return axios.post("/admin/admin-info/edit", data);
    // },
}

export default userInfo;


// WEBPACK FOOTER //
// ./src/api/userInfo.js